module.exports = __webpack_public_path__ + "static/media/chair-dog.968c031e.jpg";